var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-checkbox',_vm._g(_vm._b({class:{
      'readonly-input': _vm.$attrs.readonly
    },attrs:{"value":_vm.isChecked},on:{"click":_vm.toggleValue},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._t("label")]},proxy:true}],null,true)},'v-checkbox',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }